import { gql } from '@apollo/client';

export const GET_NOTIFICATIONS = gql`
  query notifications($args: NotificationsInput!) {
    notifications(args: $args) {
      edges {
        cursor
        node {
          id
          title
          description
          type
          parser
          assetId
          assetName
          createdAt
          entry {
            ... on CveNotificationEntry {
              cveId
            }
            ... on ComponentNotificationEntry {
              componentName
              componentVersion
              vendor
            }
            ... on BinaryProtectionsNotificationEntry {
              filePath
            }
            ... on CertificateNotificationEntry {
              filePath
              sha256Thumbprint
            }
            ... on CredentialUserNotificationEntry {
              filePath
              username
            }
            ... on CredentialHashNotificationEntry {
              filePath
              hash
            }
            ... on PrivateKeyNotificationEntry {
              filePath
              matchHash
            }
          }
          user
          isUnread
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        totalCount
      }
    }
  }
`;

export const GET_NOTIFICATIONS_SUMMARY = gql`
  query notificationsSummary {
    analytics {
      notificationsSummary {
        status {
          all
          unread
        }
        created {
          pastDay
          past3Days
          pastWeek
          pastMonth
        }
        types {
          asset
          sbom
          vulnerability
          setting
        }
      }
    }
  }
`;

export const GET_NOTIFICATION_SETTINGS = gql`
  query notificationSettings {
    notificationSettings {
      allowUserOverrides
      emailNotificationsEnabled
      notificationTimeframe
      preferences {
        name
        type
        category
        console
        consoleEnabled
        email
        emailEnabled
        webhook
        webhookEnabled
        controls {
          __typename
          ... on VulnerabilityControl {
            severities
            exploits
          }
          ... on CertificateControl {
            minValidity
            maxValidity
          }
          ... on AssetAnalysisControl {
            assetAnalysisEvents: events
          }
          ... on SbomFindingsControl {
            findings
          }
          ... on UserManagementControl {
            userManagementEvents: events
          }
        }
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation updateNotificationSettings($args: UpdateNotificationSettingsInput!) {
    updateNotificationSettings(args: $args) {
      allowUserOverrides
      emailNotificationsEnabled
      notificationTimeframe
      preferences {
        name
        type
        category
        console
        consoleEnabled
        email
        emailEnabled
        webhook
        webhookEnabled
        controls {
          __typename
          ... on VulnerabilityControl {
            severities
            exploits
          }
          ... on CertificateControl {
            minValidity
            maxValidity
          }
          ... on AssetAnalysisControl {
            assetAnalysisEvents: events
          }
          ... on SbomFindingsControl {
            findings
          }
          ... on UserManagementControl {
            userManagementEvents: events
          }
        }
      }
    }
  }
`;
